import styled, { css } from 'styled-components';

import { Sidebar } from '@treams/treams-ui';
import { EvaluationFormFragment } from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

type Props = {
	form: EvaluationFormFragment;
	selected?: Props['form'] | undefined;
	onClick: (form: Props['form']) => void;
};

export const SelectConversationTypeItem = ({ form, selected, onClick: setSelected }: Props) => {
	const { localize } = useLocalize();

	const titleLabel = localize(form.title).text;
	const active = selected?.id === form.id;

	return (
		<StyledSideBarItem
			mb={1}
			small
			title={titleLabel}
			onClick={() => setSelected(form)}
			$active={active}
		/>
	);
};

const StyledSideBarItem = styled(Sidebar.Item)<{ $active: boolean }>`
	${({ $active, theme }) =>
		$active &&
		css`
			background-color: ${theme.colors.primaryLight};
			font-weight: ${'bold'};

			color: ${theme.colors.primary};

			&:hover {
				background-color: ${theme.colors.primaryLight};
			}
		`}
`;
